import { QuizQuestion } from '@/models/_deprecated/ActivityProgress';
import Text from '@/components/ui/custom/dataDisplay/Text';
import { stringAnswer } from '@/utils/_deprecated/activities';
import { QuizAnswersType } from '@/models/_deprecated/ActivityElement';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface AnswerProps {
  value: QuizQuestion;
  index: number;
  onClickAnswer?: (answer: QuizQuestion) => void;
  selectedAnswer?: QuizQuestion;
  disabled?: boolean;
  answerType: QuizAnswersType;
  updateAnswer?: (answer: QuizQuestion) => Promise<void> | void;
}

export default function Answer(props: AnswerProps) {
  const {
    value: answer,
    answerType,
    index,
    selectedAnswer,
    updateAnswer,
    disabled,
  } = props;
  const imageType = answerType === QuizAnswersType.IMAGE;

  const selected = selectedAnswer?.id === answer.id;

  const onClick = () => updateAnswer?.(answer);

  return (
    <button
      className="self-stretch sm:w-[90%] mx-auto"
      onClick={onClick}
      disabled={disabled}
    >
      <QuizAnswerContainer
        answerType={answerType}
        selected={selected}
        index={index}
      >
        <ConditionalRenderer
          condition={imageType}
          fallback={
            <Text
              text={answer.answer}
              className={selected ? 'text-base-100' : 'text-base-content'}
            />
          }
        >
          <img className="w-[85%]" src={answer.answer} alt={answer.altText} />
        </ConditionalRenderer>
      </QuizAnswerContainer>
    </button>
  );
}

type QuizAnswerContainerProps = PropsWithChildren<{
  answerType: QuizAnswersType;
  selected?: boolean;
  className?: string;
  index: number;
}>;

export function QuizAnswerContainer({
  answerType,
  selected = false,
  children,
  className,
  index,
}: QuizAnswerContainerProps) {
  const imageType = answerType === QuizAnswersType.IMAGE;
  const imageTypeClassName = imageType
    ? 'rounded-lg'
    : 'rounded-full sm:w-[90%]';

  const letter = stringAnswer(index);
  return (
    <div
      className={twMerge(
        `
          flex w-full text-start shadow-default cursor-pointer items-center 
          justify-start py-2 px-7 min-h-16 gap-4
          duration-500 disabled:cursor-default break-words
        `,
        imageTypeClassName,
        className,
        selected ? 'bg-linear-to-tr from-primary to-secondary' : 'bg-base-100',
      )}
    >
      <span
        className={`flex w-9 h-9 rounded-full shrink-0 justify-center items-center ${
          selected ? 'text-secondary bg-base-100' : 'text-base-100 bg-secondary'
        } `}
      >
        <Text text={letter} format="rubik-500" />
      </span>
      {children}
    </div>
  );
}
